import React from "react"
import Layout from "../../components/layout"

import ScrollAnimation from "react-animate-on-scroll"
import { Link } from "gatsby"
import Seo from "../../components/seo"
import { StaticImage } from "gatsby-plugin-image"
import loadable from "@loadable/component"
import pMinDelay from "p-min-delay"

const PeaksuiteCompassSection = loadable(() =>
  pMinDelay(
    import("../../components/peaksuite-sections/PeaksuiteCompassSection"),
    500
  )
)

const Banner = () => (
  <div>
    <div className="hero-banner peaksuite-wrap-hero">
      <div className="container">
        <div
          className="hero-banner-content text-center"
          style={{ padding: "50px 0px" }}
        >
          <div
            className="hero-title-wrap text-center"
            style={{ background: "#fff" }}
          >
            <ScrollAnimation animateIn="fadeInLeft" initiallyVisible={true}>
              <Link aria-label="link" to="/peaksuite/peaksuite-compass/">
                <StaticImage
                  placeholder="blurred"
                  imgClassName="img-fluid"
                  src="../../../static/assets/productLogos/PS_compass.png"
                  alt="peakSUITE COMPASS"
                  width={400}
                  layout="constrained"
                  loading="lazy"
                />
              </Link>
            </ScrollAnimation>
          </div>
        </div>
      </div>
    </div>
  </div>
)
class ProductPeakSuite extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      title: "peakSuite | Compass",
    }
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleSubmit() {
    localStorage.setItem("title", this.state.title)
  }
  render() {
    return (
      <Layout banner={<Banner />} location={this.props.location}>
        <Seo
          title="peakSUITE Compass | Custom Add-Ons for Quickbase"
          description="This custom-built mapping tool within Quickbase provides your team a full overview of your organization's location-based processes. Learn more."
        />
        <PeaksuiteCompassSection handleSubtmit={this.handleSubmit} />
      </Layout>
    )
  }
}

export default ProductPeakSuite
